import { get, find, includes } from "lodash"
import { createSelector } from "reselect"
import { getMostUsedOrDefaultModelId } from "helpers/models"

const EMPTY_ARRAY = []
export const getAccount = state => get(state, "global.selected.account")
export const getRawTopic = state => get(state, "global.data.topic.data.resource", null)
export const getTopicPermission = state => get(state, "global.data.topic.data.resource.permissionLevel", null)
export const getTopicId = props => get(props, "params.topicId", null)
export const getFavoriteUpdating = state => get(state, "modules.researchTopicRoot.favoriteUpdating", false)
export const getModels = state => get(state, "global.data.modelsAvailability.data.models", EMPTY_ARRAY)
export const getSelectedModel = state => get(state, "modules.researchTopicRoot.selectedModel", null)
export const getPortfolios = state => get(state, "global.data.portfolios.data", EMPTY_ARRAY)
export const getSelectedDate = state => get(state, "modules.researchTopicRoot.selectedDate", null)
const getRawPortfolioDates = state => get(state, "global.data.instrumentPortfolioDates")

const getPathname = () => window.location.pathname

export const getModel = createSelector(
  [getSelectedModel, getModels, getPortfolios, getRawTopic],
  (selectedModel, models, portfolios, topic) => {
    if (topic) {
      if (selectedModel) return selectedModel

      return getMostUsedOrDefaultModelId(portfolios, models)
    }

    return null
  },
)

export const getModelAvailability = createSelector(
  [getModel, getModels],
  (selectedModel, models) => {
    const modelData = find(models, { id: selectedModel })
    return get(modelData, "availability")
  },
)

export const getLocation = createSelector(
  [getPathname],
  (pathname) => {
    if (includes(pathname, "smart-trade")) {
      return "smart-trade"
    }

    return "root"
  },
)

export const getPortfolioInfo = createSelector(
  [getRawTopic, getPortfolios],
  (topic, portfolios) => {
    if (get(topic, "referenceInstrument.type") !== "PORTFOLIO") { return null }
    return find(portfolios, ({ id }) => id === topic.referenceInstrument.portfolioId)
  },
)

export const getPortfolioDates = createSelector(
  [getRawPortfolioDates],
  (dates) => ({
    earliest: get(dates, "data.availableFrom"),
    latest: get(dates, "data.latestUploadedDate"),
  }),
)
